<template>
  <div class="select-in-popup-wrap" ref="select_wrap" v-if="start">
    <v-select
      :value="value"
      @input="$emit('input', $event)"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      v-bind="$attrs"
      ref="select"
    >
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'SelectInPopup',

  props: {
    value: {
      required: true
    },
    delay: {
      type: Number,
      default: 200
    }
  },

  data () {
    return {
      start: false
    }
  },

  watch: {
    value: {
      deep: true,
      handler () {
        setTimeout(() => {
          this.handleResize()
        }, 0)
      }
    }
  },

  methods: {
    handleResize () {
      const width = this.$refs.select_wrap.getBoundingClientRect().width || '420'
      this.$refs.select.$el.style.width = `${width}px`
      this.$refs.select_wrap.style.height = `${this.$refs.select.$el.offsetHeight}px`
    }
  },

  async mounted () {
    this.handleResize = this.handleResize.bind(this)

    this.start = true

    setTimeout(() => {
      this.handleResize()
      window.addEventListener('resize', this.handleResize)
    }, this.delay)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize, false)
  }
}
</script>

<style lang="scss">
  .select-in-popup-wrap {
    height: 38px;

    .v-select {
      position: absolute;
      width: 419px;
    }

    .vs__selected-options {
      flex-wrap: wrap !important;
      overflow: auto;
    }

    .vs__selected {
      flex: 0 0 auto;
    }
  }
</style>
